import { Component, Host, h, Listen, State, Element } from '@stencil/core';
import { gettrackmeEventCategory, gettrackmeEventObject } from '../../../utils/tracking-helpers';

@Component({
    tag: 'sew-ws-services',
    styleUrl: 'sew-ws-services.scss',
    shadow: true,
})
export class SewWsServices {
    @Element() host: HTMLSewWsServicesElement;

    @State() activePanel: HTMLSewWsServicesItemElement;

    @Listen('itemClickedEmitter')
    itemClickedHandler(event: CustomEvent): void {
        this.activatePanel(event.detail.clickedItem, event.detail.active);
    }

    private checkIfBelowStage(): void {
        let previousSibling = this.host.previousSibling;

        // skip textnodes
        while (previousSibling && (previousSibling.nodeType != 1 || previousSibling.nodeName === 'A')) {
            previousSibling = previousSibling.previousSibling;
        }

        if (!previousSibling || previousSibling.nodeName !== 'SEW-WS-STAGE') {
            this.host.classList.add('spacing');
        }
    }

    private activatePanel = (clickedItem: HTMLSewWsServicesItemElement, active: boolean) => {
        for (let i = 0; i < this.host.children.length; i++) {
            const currentElement = this.host.children[i] as HTMLSewWsServicesItemElement;

            if (!!this.activePanel && currentElement === clickedItem && this.activePanel !== clickedItem) {
                currentElement.openContent = true;
            } else {
                currentElement.openContent = false;
            }

            if (currentElement === clickedItem) {
                currentElement.active = active;
                this.activePanel = active ? currentElement : null;
            } else {
                currentElement.active = false;
            }
        }
    };

    private renderPanels = () => {
        return Array.from(this.host.children).map((panel: HTMLSewWsServicesItemElement) => {
            return (
                <button
                    onClick={() => this.activatePanel(panel, !panel.active)}
                    class={{
                        panel: true,
                        active: panel === this.activePanel,
                        inactive: !!this.activePanel && this.activePanel !== panel,
                    }}
                    data-sew-trackme-event-category={gettrackmeEventCategory('Services ')}
                    data-sew-trackme-event-object={gettrackmeEventObject('Services_' + panel.label)}
                    data-sew-trackme-event-action="Click"
                >
                    <sew-icon class="service-svg" icon={panel.icon} size="xl" height="96px" width="96" />
                    <h2>{panel.label}</h2>
                    <sew-icon class="arrow-svg" icon="arrow-down" size="l" />
                </button>
            );
        });
    };

    componentDidLoad(): void {
        this.checkIfBelowStage();
    }

    render() {
        return (
            <Host>
                <div class="panels">
                    <div class="panel-grid">
                        <div class="panel-wrapper">{this.renderPanels()}</div>
                    </div>
                </div>
                <slot></slot>
            </Host>
        );
    }
}
